<template>
    <div class="pb-30">
        <md-card class="mt-30 response-filter">
            <md-card-header class="ask-subject community-filter-custome">
                <div class="md-layout sort-order-xsmall-100">
                    <div class="md-layout-item">
                        <label>Responses</label>
                    </div>
                    <div class="md-layout-item">
                        <md-field class="align-right create-community w-50">
                            <md-select name="community" placeholder="Community" v-model="selectedCommunity" id="community" aria-label="Select community to filter">
                                <md-option value="all">All</md-option>
                                <md-option v-for="(singleCommunity) in allCommunities" v-bind:key="singleCommunity._id" :value="singleCommunity._id">{{ singleCommunity.name }}</md-option>
                              </md-select>
                        </md-field>
                    </div>
                </div>
            <!-- <span>Responses</span>
            <div class="md-layout-item">
                <md-field class="align-right create-community w-50">
                    <md-select name="community" placeholder="Community" v-model="selectedCommunity" id="community">
                        <md-option value="all">All</md-option>
                        <md-option v-for="(singleCommunity) in allCommunities" v-bind:key="singleCommunity._id" :value="singleCommunity._id">{{ singleCommunity.name }}</md-option>
                    </md-select>
                </md-field>
            </div> -->
            <!--
            <ul class="list-inline align-right">
            <li>
                <md-field class="dropdown-field">
                    comment<label for="movie">Status</label>
                    <md-select v-model="status">
                        <md-option value="In Review">In Review</md-option>
                        <md-option value="Approved">Approved</md-option>
                        <md-option value="Rejected">Rejected</md-option>
                    </md-select>
                </md-field>
            </li>
            <li>
                <md-button class="md-mini md-fab btnplain">
                    comment<font-awesome-icon class='selector' icon="caret-up" />
                    <font-awesome-icon class='selector' icon="caret-down" />
                </md-button>
            </li>
            </ul>
            -->
            </md-card-header>
        </md-card>
        <div v-if="count == '0'">
          <md-empty-state
            md-label="No Response Found"
            md-description="Please select another community.">
          </md-empty-state>
        </div>
        <template v-if="count && count > 0" v-for="response in responses"  >
            <md-card v-if="$lodash.has(response.ask, 'text')" :key="response.ask._id" class="mt-30">
                <md-card-header>
                    <router-link :to="`/asks/${response.ask._id}/request`" class="remove-link"><div class="ask-subject" :style="{backgroundColor: response.community.customSettings.primaryColor, color: response.community.customSettings.secondaryColor}" v-text="$lodash.has(response.community, 'name') ? response.community.name + ': ' + response.ask.subject : response.ask.subject"></div></router-link>
                </md-card-header>
                <md-card-content class="md-scrollbar scrollbar">
                    <md-table class="response-section-table">
                        <md-table-row>
                            <md-table-head class="card-header remove-table-head-margin">Adviser</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin">Email</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin">Community</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin">Received</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin">Responded</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin">Status</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin">Response</md-table-head>
                        </md-table-row>
                        <template v-for="(give, index) in response.ask.gives">
                        <!--<md-table-row class="response-section" :key="give._id" v-if="give.responseState.currentState && give.responseState.currentState == status && give.helpaction == 'yes' && ['Insight', 'Share Advice'].includes(give.action)" v-on:click="expandResponseSection(give._id);giveId = give._id">-->

                        <md-table-row class="response-section" :key="give._id" v-if="['In Review', 'Pending'].includes(give.responseState.currentState) && give.helpaction == 'yes' && (['Insight', 'Share Advice', 'Call Me'].includes(give.action) || give.action.search(/Let's Connect/i) == 0)" v-on:click="expandResponseSection(give._id);giveId = give._id">
                            <md-table-cell v-if="give.advisors && give.advisors.length"><span class="display-link" @click="goToProfile(give.advisors[0]._id)">{{give.advisors && give.advisors.length ? getAdviserByName(give.advisors) : 'N/A'}}</span></md-table-cell>
                            <md-table-cell v-else>N/A</md-table-cell>
                            <md-table-cell>{{give.advisors && give.advisors.length ? getAdviserByEmail(give.advisors) : give.email}}</md-table-cell>
                            <md-table-cell>{{response.community ? response.community.name  : 'N/A'}}</md-table-cell>
                            <md-table-cell>{{give.advisors && give.advisors.length ? getAdviserRequestDate(response.ask, give.advisors[0]._id) : 'N/A'}}</md-table-cell>
                            <md-table-cell>{{give.when | momentDate}}</md-table-cell>
                            <md-table-cell :class="[{'md-orange-color': ['In Review', 'Pending'].includes(give.responseState.currentState)}, {'md-green-color': give.responseState.currentState === 'Approved'}, {'md-red-color': give.responseState.currentState === 'Rejected'}]" v-if="give.responseState.currentState">{{give.responseState.currentState}}</md-table-cell>
                            <md-table-cell v-else>N/A</md-table-cell>
                            <md-table-cell>{{give.action ? getResponseAction(give.action) : 'Advice'}}</md-table-cell>
                        </md-table-row>
                            <div class="table-row mt-20" v-if="responseSectionArr.includes(give._id) && give.responseState.currentState != 'Approved' && give.responseState.currentState != 'Pending'" :key="'approve-response-'+give._id">
                            <md-table-cell colspan="7">
                                <textarea class="response-description" :id="'response-id-'+index" :data-id="'response-id-'+index" v-model.trim="give.insight" @change="editResponse(response.ask._id, give)" v-if="give.action != 'Call Me'"></textarea>
                                <md-card-actions class="card-actions">
                                    <md-button :class="[{'md-orange': action === 'Reject'}, 'md-raised', 'md-accent', 'md-round', 'float-right', 'capitalize', 'md-white-color', 'm-left-10']" v-for="action in give.responseState.availableStates" :interaction="action" :key="action" @click="doInteraction(response.ask._id, give._id, action)">{{ action }}
                                    </md-button>
                                </md-card-actions>
                            </md-table-cell>
                            </div>
                        </template>
                    </md-table>
                    <!--<div class="response-flex-box response-section" :key="give._id" v-if="give.responseState.currentState && give.helpaction == 'yes'" v-on:click="expandResponseSection(give._id)">
                        <div class="response-flex-child responded-advisor-details remove-margin">
                            <span class="ask-header">Adviser</span>
                            <span class="">{{give.advisors && give.advisors.length ? getAdviserById(give.advisors.toString()) : '---'}}</span>
                        </div>
                        <div class="response-flex-child responded-advisor-details remove-margin">
                            <span class="ask-header">Email</span>
                            <span class="">{{give.advisors && give.advisors.length ? getAdviserByEmail(give.advisors.toString()) : give.email}}</span>
                        </div>
                        <div class="response-flex-child responded-advisor-details remove-margin">
                            <span class="ask-header">Received</span>
                            <span class="">{{give.advisors && give.advisors.length ? getAdviserRequestDate(give.advisors.toString()) : '---'}}</span>
                        </div>
                        <div class="response-flex-child responded-advisor-details remove-margin">
                            <span class="ask-header">Responded</span>
                            <span class="">{{give.when | momentDate}}</span>
                        </div>
                        <div class="response-flex-child responded-advisor-details remove-margin">
                            <span class="ask-header">Status</span>
                            <span :class="[{'md-orange-color': give.responseState.currentState === 'In Review'}, {'md-green-color': give.responseState.currentState === 'Approved'}, {'md-red-color': give.responseState.currentState === 'Rejected'}]" v-if="give.responseState.currentState">{{give.responseState.currentState}}</span>
                            <span class="" v-else>---</span>
                        </div>
                        <div class="response-flex-child responded-advisor-details remove-margin">
                            <span class="ask-header">Response</span>
                            <span class="">{{give.action ? getResponseAction(give.action) : 'Advice'}}</span>
                        </div>
                    </div>
                    <div class="approve-response-section mt-20" v-if="responseSectionArr.includes(give._id)" :key="'approve-response-'+give._id">
                        <p class="response-description">{{give.insight}}</p>
                        <md-card-actions class="card-actions">
                        <md-button :class="[{'md-orange': action === 'Reject'}, 'md-raised', 'md-accent', 'md-round', 'float-right', 'capitalize', 'md-white-color']" v-for="action in give.responseState.availableStates" :interaction="action" :key="action" @click="doInteraction(response.ask._id, give._id, action)">{{ action }}
				        </md-button>
                        </md-card-actions>
                    </div>
                    </template>-->
                </md-card-content>
            </md-card>
        </template>
        <md-button class="md-fab loadmore-button" v-on:click="loadMore()" v-if="skip + limit < count" aria-label="Load more results">
            <md-tooltip md-direction="left">Load more</md-tooltip>
            <md-icon><font-awesome-icon icon="recycle"/></md-icon>
        </md-button>
    </div>
</template>

<script>
import API from "../services/API";
export default {
    name: 'NewResponses',
    data() {
        return {
            ask: '',
            api: new API(),
            responses: [],
            advisers: [],
            responseSectionArr: [],
            name: '',
            communities: [],
            giveId: '',
      		fullPage: true,
            //status: '',
            displayAskOrNot: [],
            skip: 0,
            limit: 25,
            count: 0,
            allCommunities: [],
            selectedCommunity: ""
        }
    },
    created() {
        this.loadData();
        this.getAllCommunity();
        //this.status = 'In Review';
    },
    mounted() {
        // this.$nextTick(() => {
        //     this.status = 'In Review';
        // });
    },
    watch: {
        giveId: "calculateHeight",
        selectedCommunity: function(event) {
          this.loadData();
        }
        //status: "filterResponses"
    },
    methods: {
        loadData: async function() {
            this.skip = 0;
            this.limit = 25;
            this.count = 0;
            await this.api.get(`asks/responses?limit=${this.limit}&skip=${this.skip}&community=${this.selectedCommunity}`).then(responses => {
                if (Array.isArray(responses.data.returnData) &&
                    responses.data.returnData.length > 0) {
                    this.responses = responses.data.returnData;
                }
                this.count = responses.data.count;
            });
        },
        getAllCommunity: async function () {
         await this.api.get(`communities/all`).then(communities => {
            this.allCommunities = communities.data;
          });
        },
        getAdviserRequestDate(ask, Id) {
            if (ask.advisorFlags && ask.advisorFlags.length) {
                let adviser = ask.advisorFlags.filter(advisorFlag => advisorFlag.advisor === Id && advisorFlag.firstRequestSent)
                if (adviser && adviser.length && adviser[0].firstRequestSent) {
                    return this.$moment(adviser[0].firstRequestSent).tz("America/New_York").format('MM/DD/YYYY HH:mm');
                } else {
                    return 'N/A';
                }
            } else {
                return 'N/A';
            }
        },
        getAdviserByEmail: function(adv) {
            return adv[0].emails ? adv[0].emails[0] : 'N/A';
        },
        expandResponseSection(Id) {
            let index = this.responseSectionArr.indexOf(Id);
            if (index >= 0) {
                this.responseSectionArr.splice(index, 1);
            } else {
                this.responseSectionArr.push(Id);
            }
        },
        doInteraction: async function(askId, giveId, action) {
            await this.api.get(`asks/${askId}`).then(async ask => {
                this.ask = ask.data;
                if (ask.data.status !== '(8) Rejected' && ask.data.status !== '(7) Closed') {
                    await this.api.post(`asks/${askId}/response-actions`, {giveId: giveId, action: action}).then((response) => {
                        this.loadData();
                        this.$emit('response-count');
                    });
    			} else {
    				// console.log("this.community :", this.ask.community);
                    let closeMessage = this.ask.community.content.closeRequestMessage;
                    this.$toast.error(closeMessage);
    			}
            });
        },
        getResponseAction(action) {
            if (action.match(/Share Advice/i)) {
                return 'Advice';
            } else if (action.match(/Call Me/i)) {
                return 'Call';
            } else if (action.match(/Let's Connect/i)) {
                return 'Let\'s Connect';
            } else {
                return 'Advice';
            }
        },
        editResponse: async function(askId, give) {
            await this.api.get(`asks/${askId}`).then(async ask => {
                this.ask = ask.data;
                if (ask.data.status !== '(8) Rejected' && ask.data.status !== '(7) Closed') {
                    if (give.insight && give.insight.length) {
                        await this.api.put(`asks/${askId}/request/edit-give`, {give: give._id, insight: give.insight}).then(response => {
                            this.loadData();
                        });
                    }
    			} else {
    				// console.log("this.community :", this.ask.community);
                    let closeMessage = this.ask.community.content.closeRequestMessage;
                    this.$toast.error(closeMessage);
    			}
            });
        },
        calculateHeight() {
            if (this.responseSectionArr.includes(this.giveId) === true) {
                this.$nextTick(() => {
                    let give = $('.response-description').attr('data-id');//.split('-').pop();
                    if (give && give.match(/response-id/i)) {
                        let content = $(`#${give}`).val();
                        var div = $('<div id="temp"></div>').text(content).css({'display': 'none', 'overflow-wrap': 'break-word', 'white-space': 'pre-line'});
                        $('body').append(div);
                        var divHeight = div.height();
                        $(`#${give}`).css({
                            height: divHeight + 10
                        });
                        div.remove();
                    }
                });
            }
        },
		goToProfile: function(Id) {
			let route = this.$router.resolve({path: `/members/${Id}`});
			window.open(route.href, '_blank');
        },
        async loadMore() {
            this.skip = this.skip + this.limit;
            if (this.skip < this.count) {
                await this.api.get(`asks/responses`, {params: { limit: this.limit, skip: this.skip, community: this.selectedCommunity }}).then(responses => {
                    if (Array.isArray(responses.data.returnData) && responses.data.returnData.length > 0) {
                        this.responses = [...this.responses, ...responses.data.returnData];
                    }
                    this.count = responses.data.count;
                });
            }
        },
        getAdviserByName(adv) {
            return adv[0].first && adv[0].last ? adv[0].first + ' ' + adv[0].last : adv[0].emails[0];
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/NewResponses.vue